/* ─── East West Product House — Main init ──────────────────────────── */ 'use strict';
/* Smooth anchor scroll with offset for fixed navbar */ (function() {
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
        anchor.addEventListener('click', function(e) {
            const id = this.getAttribute('href');
            if (id === '#') return;
            const target = document.querySelector(id);
            if (!target) return;
            e.preventDefault();
            const navHeight = document.getElementById('navbar')?.offsetHeight ?? 80;
            const top = target.getBoundingClientRect().top + window.scrollY - navHeight - 8;
            window.scrollTo({
                top,
                behavior: 'smooth'
            });
        });
    });
})();
/* Year in footer copyright */ (function() {
    const el = document.getElementById('footer-year');
    if (el) el.textContent = new Date().getFullYear();
})();

//# sourceMappingURL=project-6a0985f11bbc35ebaa3a06b4.ddec5e76.js.map
